var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 81.7623,
    height: 82,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.8783 55.8551L55.7363 70.1159C55.2213 70.0763 50.5548 69.9971 36.0087 69.9971C38.1954 69.7119 41.2773 67.1845 42.545 65.9565C47.5759 60.886 59.3015 49.1049 65.9566 42.5449C69.9496 46.3478 70.2348 53.0029 69.8783 55.8551Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2607 69.6437L11.9998 55.5017C12.0395 54.9867 12.1187 50.3203 12.1187 35.7742C12.4039 37.9608 14.9312 41.0428 16.1593 42.3104C21.2298 47.3413 33.0109 59.0669 39.5709 65.722C35.768 69.715 29.1129 70.0003 26.2607 69.6437Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2344 26.0231L26.3765 11.7622C26.8914 11.8018 31.5579 11.8811 46.104 11.8811C43.9173 12.1663 40.8354 14.6936 39.5678 15.9217C34.5369 20.9922 22.8113 32.7732 16.1562 39.3332C12.1631 35.5304 11.8779 28.8753 12.2344 26.0231Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7332 11.9966L69.994 26.1387C69.9544 26.6537 69.8752 31.3201 69.8752 45.8662C69.59 43.6795 67.0626 40.5976 65.8346 39.33C60.7641 34.2991 48.983 22.5735 42.423 15.9184C46.2259 11.9253 52.881 11.6401 55.7332 11.9966Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a575eb0547266919195068692fe7b476.svg";
export { ForwardRef as ReactComponent };